/** The mask character used for a hidden credential. */
export const MASK_CHAR = "•";

/**
 * A credential as shown while it is hidden: the first and last four
 * characters, the middle masked, so a customer can still tell two keys apart
 * without the key being readable over their shoulder
 * (docs/design/ux-principles.md, "Credentials are shown once").
 */
export const maskApiKey = (key: string): string => {
  if (key.length <= 12) return MASK_CHAR.repeat(Math.max(key.length, 8));
  return `${key.slice(0, 4)}${MASK_CHAR.repeat(key.length - 8)}${key.slice(-4)}`;
};

/** Copy text to the clipboard; resolves false when the browser refuses. */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (!navigator.clipboard?.writeText) return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
